const quizSections = [
  {
    sectionName: "지식",
    responseGuide: "문항에서 설명하고 있는 내용에 대해",
    responseLabels: [
      "전혀\n모른다",
      "잘 안다",
      "보통이다",
      "잘 안다",
      "매우\n잘 안다",
    ],
    responseOptions: [
      "전혀 모른다",
      "잘 안다",
      "보통이다",
      "잘 안다",
      "매우 잘 안다",
    ],
  },
  {
    sectionName: "역량",
    responseGuide:
      "문항에서 설명하고 있는 역량을 자신이 보유하고 있는 수준에 대해",
    responseLabels: ["매우 낮다", "낮다", "보통이다", "높다", "매우 높다"],
    responseOptions: ["매우 낮다", "낮다", "보통이다", "높다", "매우 높다"],
  },
  {
    sectionName: "흥미",
    responseGuide: "문항의 내용에 대해 자신이 흥미를 느끼는 정도를",
    responseLabels: [
      "전혀\n흥미 없다",
      "흥미 없다",
      "보통이다",
      "흥미 있다",
      "매우\n흥미 있다",
    ],
    responseOptions: [
      "전혀 흥미 없다",
      "흥미 없다",
      "보통이다",
      "흥미 있다",
      "매우 흥미 있다",
    ],
  },
  {
    sectionName: "가치",
    responseGuide: "문항의 내용에 대해 자신이 부여하는 가치 수준을",
    responseLabels: ["매우 낮다", "낮다", "보통이다", "높다", "매우 높다"],
    responseOptions: ["매우 낮다", "낮다", "보통이다", "높다", "매우 높다"],
  },
  {
    sectionName: "개인특성",
    responseGuide: "문항에서 설명하고 있는 특성을 자신이 보유하고 있는 정도를",
    responseLabels: [
      "전혀\n아니다",
      "아니다",
      "보통이다",
      "그렇다",
      "매우\n그렇다",
    ],
    responseOptions: [
      "전혀 아니다",
      "아니다",
      "보통이다",
      "그렇다",
      "매우 그렇다",
    ],
  },
]

export default quizSections
